module.exports = __webpack_public_path__ + "static/media/v2_7.202a264c.png";